"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanObject = exports.getLinearizedKeys = exports.linearize = exports.nest = exports.deepMerge = exports.isObject = exports.isJoi = exports.compareWithArray = exports.compareObj = exports.sortByProp = exports.lower = exports.removePrefix = exports.hasProp = exports.isEmpty = exports.updateObject = exports.set = exports.get = exports.removeProps = exports.removeProp = exports.keepProps = exports.deserialize = exports.unique = exports.groupBy = exports.transpose = exports.distinct = void 0;
const string_1 = require("./string");
exports.distinct = (arr) => [...new Set(arr)];
exports.transpose = (arr, fn = (a) => a) => {
    const r = {};
    Object.keys(arr).map((idx) => {
        return Object.keys(arr[idx]).map((d) => {
            if (!r[d]) {
                r[d] = {};
            }
            r[d][idx] = fn(arr[idx][d]);
            return true;
        });
    });
    return r;
};
exports.groupBy = (arr, key) => {
    const callback = (acc, v) => {
        (acc[exports.get(key, v)] = acc[exports.get(key, v)] || []).push(v);
        return acc;
    };
    const r = {};
    return arr.reduce(callback, r);
};
exports.unique = (arr, prop) => {
    const temp = arr.map((obj) => {
        return prop ? exports.get(prop, obj) : obj;
    });
    return arr.filter((obj, i) => temp.indexOf(prop ? exports.get(prop, obj) : obj) == i);
};
exports.deserialize = (str) => str.split(",").reduce((r, item) => {
    const arr = item.split("=");
    if (arr.length === 2) {
        const [key, value] = arr;
        return { ...r, [key]: value };
    }
    return r;
}, {});
exports.keepProps = (obj, props) => {
    if (!props || !Array.isArray(props))
        return obj;
    return Object.entries(obj).reduce((acc, [key, value]) => props.includes(key) ? { ...acc, [key]: value } : acc, {});
};
exports.removeProp = (obj, prop) => Object.keys(obj).reduce((acc, key) => (key !== prop ? { ...acc, [key]: obj[key] } : acc), {});
exports.removeProps = (obj, props) => {
    while (props.length > 0) {
        obj = exports.removeProp(obj, props.pop());
    }
    return obj;
};
exports.get = (p, o) => {
    return p.split(".").reduce((xs, x) => {
        if (xs && (xs[x] || xs[x] === 0 || xs[x] === false))
            return xs[x];
        else
            return null;
    }, o);
};
exports.set = (name, value, obj) => {
    const keyArray = name.split(".");
    const l = keyArray.length;
    let f = obj;
    keyArray.map((k, i) => {
        if (i === l - 1) {
            f[k] = value;
        }
        else {
            if (!f[k]) {
                f[k] = {};
            }
        }
        f = f[k];
    });
    return obj;
};
exports.updateObject = (form, newObj) => exports.set(newObj.name, newObj.value, form);
exports.isEmpty = (obj) => {
    if (Array.isArray(obj))
        return false;
    if (!obj)
        return true;
    for (let key in obj)
        if (obj.hasOwnProperty(key))
            return false;
    return true;
};
exports.hasProp = (o, prop) => !exports.isEmpty(o) && prop && prop in o;
exports.removePrefix = (obj, prefix) => {
    if (obj.data)
        return obj.data;
    return Object.keys(obj).reduce((a, key) => ({ ...a, [key.replace(prefix, "")]: obj[key] }), {});
};
exports.lower = (value) => {
    if (typeof value === "number")
        return value;
    if (value && value.length > 0) {
        return value.toLowerCase();
    }
    return "";
};
exports.sortByProp = (arr, attr = "name", asc = true) => {
    if (!arr)
        return null;
    const compare = (a, b) => {
        let attrA = exports.lower(string_1.removeWhitespace(String(exports.get(attr, a))));
        let attrB = exports.lower(string_1.removeWhitespace(String(exports.get(attr, b))));
        let comparison = 0;
        if (attrA > attrB)
            comparison = 1;
        else
            comparison = -1;
        return asc ? comparison : comparison * -1;
    };
    return arr.sort(compare);
};
exports.compareObj = (a, b, attr) => {
    let valueA = exports.get(attr, a);
    let valueB = exports.get(attr, b);
    if (!valueA || !valueB) {
        return 0;
    }
    if (typeof valueA === "string") {
        valueA = valueA.toLowerCase();
    }
    if (typeof valueB === "string") {
        valueB = valueB.toLowerCase();
    }
    return valueA.localeCompare(valueB);
};
exports.compareWithArray = (newRecord, oldRecords, isRecordFound, isDuplicate = (x) => false, isNotNull = (x) => true) => {
    const recordFound = oldRecords.find((x) => isRecordFound(newRecord, x));
    if (recordFound) {
        if (isDuplicate(recordFound, newRecord)) {
            return { edit: true, data: newRecord, id: recordFound.id };
        }
        else {
            return {
                duplicate: true,
                id: recordFound.id,
                message: "the same figure was already found in the system",
                data: newRecord,
            };
        }
    }
    else {
        if (isNotNull(newRecord)) {
            return { add: true, data: newRecord };
        }
        else {
            return {
                warning: true,
                message: "not imported the value is non existent (null)",
                data: newRecord,
            };
        }
    }
};
exports.isJoi = (schema) => schema.hasOwnProperty("$_root") || schema.hasOwnProperty("$_super");
exports.isObject = (item) => {
    if (!item)
        return false;
    if (exports.isJoi(item))
        return false;
    else
        return typeof item === "object" && !Array.isArray(item) && item !== null;
};
exports.deepMerge = (target, source) => {
    if (exports.isObject(target) && exports.isObject(source)) {
        Object.entries(source).forEach(([key, sourceValue]) => {
            if (exports.isObject(sourceValue)) {
                if (!target[key]) {
                    Object.assign(target, { [key]: {} });
                }
                const next = target[key];
                exports.deepMerge(next, sourceValue);
            }
            else {
                Object.assign(target, { [key]: sourceValue });
            }
        });
    }
    return target;
};
exports.nest = (data = null, props = []) => {
    if (data === undefined || data === null)
        return null;
    if (props.length === 0) {
        if (!Array.isArray(data)) {
            data = Object.entries(data).map(([key, value]) => ({ key, value }));
        }
        if (data.length === 0)
            return {};
        let nested = {};
        data.forEach(({ key, value }) => {
            const props = key.split(".");
            const obj = exports.nest(value, props);
            nested = exports.deepMerge(nested, obj);
        });
        return nested;
    }
    else {
        const value = data;
        const [prop, ...rest] = props;
        if (rest.length === 0) {
            return { [prop]: value };
        }
        const result = exports.nest(value, [...rest]);
        return { [prop]: result };
    }
};
exports.linearize = (obj, keys = []) => {
    let list = [];
    Object.entries(obj).map(([key, value]) => {
        const next = [...keys, key];
        if (exports.isObject(value)) {
            const subList = exports.linearize(value, next);
            list = [...list, ...subList];
        }
        else {
            list.push({ key: next.join("."), value });
        }
    });
    return list;
};
exports.getLinearizedKeys = (o) => {
    return Object.keys(o)
        .map((key) => {
        let value = o[key];
        if (value != null && typeof value == "object") {
            const nestedKeys = exports.getLinearizedKeys(value);
            return nestedKeys.map((item) => `${key}.${item}`);
        }
        else
            return key;
    })
        .flat();
};
exports.cleanObject = (obj, removeNull = true) => {
    for (const propName in obj) {
        if (removeNull && obj[propName] === null) {
            delete obj[propName];
        }
        else if (obj[propName] === undefined) {
            delete obj[propName];
        }
        else {
            if (typeof obj[propName] === "object" && obj[propName] !== null) {
                exports.cleanObject(obj[propName], removeNull);
            }
        }
    }
};
